package com.essntl.features.service.ui.components.richtext

import androidx.compose.foundation.layout.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.input.EsRichInput
import com.essntl.uikit.components.utils.spacing
import com.mohamedrejeb.richeditor.model.RichTextState
import core.validation.EsInputState

@Composable
fun ServiceRichTextEditor(
    richTextState: RichTextState,
    enabled: Boolean = true,
    message: String? = null,
    state: EsInputState = EsInputState.Default,
    modifier: Modifier = Modifier,
    aiEnabled: Boolean = false,
    onRewriteWithAI: () -> Unit,
) {
    Column(
        modifier = modifier,
    ) {
        RichEditorPanel(
            richTextState = richTextState,
            enabled = enabled,
            aiEnabled = aiEnabled,
            onRewriteWithAI = onRewriteWithAI,
            modifier =
                Modifier
                    .fillMaxWidth(),
        )

        Spacer(modifier = Modifier.height(2.spacing))

        EsRichInput(
            richTextState = richTextState,
            placeholder = "Add here some description for the service",
            message = message,
            state = state,
            enabled = enabled,
            modifier =
                Modifier
                    .fillMaxWidth()
                    .heightIn(min = 100.dp),
        )
    }
}
